import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import videos from "./videos"
import images from "./images"
import bancos from "./bancos";

export default combineReducers({
  auth,
  message,
  videos,
  images,
  bancos
});